import { GenieIcon } from "@/components/ui/genie-icons/GenieIcon";
const IntegrationsHeader = () => {
  return (
    <div className="flex items-start sm:items-center gap-3 sm:gap-4">
      <GenieIcon
        name="database"
        size={24}
        label="Integrations"
        className="h-6 w-6 sm:h-7 sm:w-7 md:h-8 md:w-8 flex-shrink-0 mt-1 sm:mt-0"
      />
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-[#222B45]">Integrations</h1>
        <p className="text-xs sm:text-sm text-[#64748B] mt-1">
          Configure private data sources that your genies can search
        </p>
      </div>
    </div>
  );
};

export default IntegrationsHeader;
